import { template as template_ac6a6059b60e4a6a94feaf3ab6dd9562 } from "@ember/template-compiler";
import Captcha from 'client-portal/components/captcha';
import t from 'ember-intl/helpers/t';
export default template_ac6a6059b60e4a6a94feaf3ab6dd9562(`
  <div class="controls">
    <div class="row justify-content-between align-items-end">
      <div class="col-sm-5">
        {{#unless @isRecaptchaDisabled}}
          <Captcha @model={{@form}} />
        {{/unless}}
      </div>

      <div class="col-sm-4">
        <button
          class="button primary"
          type="submit"
          disabled={{@isSubmitting}}
          data-test-join-waitlist-submit
        >
          {{t "site.waitlistIntake.actions.joinWaitlist"}}
        </button>
      </div>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
